export function InvoiceActivityLogCtrl ($scope, $translate, workshopAPI) {
	$scope.showActivityLog = false;

  $scope.tableSettings = {
    columns: [
      {
				classes: 'all-caps',
				field  : 'activity_type',
				header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.TYPE')
        }
			},
			{
				field : 'local_log_time',
				header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
				pipe: 'dateTime'
			},
			{
				field : 'activity',
				header: {
          text: $translate.instant('INVOICE_SPACE.ACTIVITY')
        }
			},
			{
				field : 'username',
				header: {
          text: $translate.instant('COMPANY_SPACE.USERS.USER')
        }
			}
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_ACTIVITY_LOGS'),
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/invoice_activity_logs/invoice_activity_log_count', $scope.invoice.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

	$scope.onRowDoubleClick = function (event) {
		$scope.Invoice.getActivity(event.row);
	};

  $scope.getLogs = ( params ) => {
    return workshopAPI.get('/invoice_activity_logs/get_invoice_activity_log', [
      $scope.invoice.id,
      params.offset,
      params.pageSize,
    ]).then(logs => {
      $scope.logs = logs;

      return logs;
    });
  };

	$scope.refreshGrid = function () {
		$scope.getLogs({ offset: 0, pageSize: 5 });
	};

	$scope.getLogs({ offset: 0, pageSize: 5 });
}